export default "__VITE_ASSET__3157c130__"